export default __webpack_public_path__ + "c64e27c6c32a7a908c373d233a8855d3.png";